<template>
  <div class="applicant-form">
    <validation-observer ref="validator" v-slot="{ invalid, handleSubmit }" tag="div">
      <t-form @submit.native.prevent="handleSubmit(submit)">
        <t-validation-wrapper
          vid="available_from"
          :name="$t('fields.available_from')"
          :label="$t('fields.available_from')"
          rules="required"
        >
          <t-datepicker v-model="form.available_from">
            <t-icon slot="right" icon="calendar" />
          </t-datepicker>
        </t-validation-wrapper>

        <t-validation-wrapper
          v-if="$store.state.tenant.tenant.supports_relocation_feature"
          vid="relocation"
          :name="$t('fields.would_relocate')"
          no-label
          rules="required"
        >
          <t-switch v-model="wouldRelocate">
            {{ $t('fields.would_relocate') }}
          </t-switch>
        </t-validation-wrapper>

        <slot name="footer" :invalid="invalid" :loading="loading" />
      </t-form>
    </validation-observer>
  </div>
</template>
<script>
import Vue from 'vue';
import FormBaseMixin from '../../FormBaseMixin';
import Applicant from '~/models/Applicant';
import TDatepicker from '~/components/TDatepicker';
import OccupationSelect from '~/components/ResourceSelect/OccupationSelect';
import EnumSelect from '~/components/EnumSelect/EnumSelect';
import RelocationEnum from "~/enums/RelocationEnum";

export default Vue.extend({
  components: {
    TDatepicker,
    OccupationSelect,
    EnumSelect,
  },

  mixins: [FormBaseMixin],

  props: {
    applicant: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    form: null,
  }),

  created() {
    this.form = this.getForm(this.applicant);
  },

  computed: {
    wouldRelocate:{
      get() {
        return this.form.relocation === RelocationEnum.AVAILABLE;
      },
      set(value) {
        this.form.relocation = value ? RelocationEnum.AVAILABLE : RelocationEnum.UNAVAILABLE;
      }
    }
  },

  methods: {
    async request(payload) {
      const model = await new Applicant({ id: this.applicant.id, ...payload }).patch();
      this.$emit('updated', model);

      return model;
    },

    getForm(model = null) {
      return {
        available_from: model?.available_from,
        relocation: this.getInitialRelocation(model?.relocation),
      };
    },

    getInitialRelocation(relocation){
      if(!relocation || relocation === RelocationEnum.UNKNOWN){
        return RelocationEnum.UNAVAILABLE;
      }

      return relocation;
    },

    getPayload() {
      return { ...this.form };
    },
  },
});
</script>
